import React from "react";
import "../Accessories/Accessories.css";
import AccessoriesHero from "../../components/pages/Accessories/AccessoriesHero/AccessoriesHero";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import ContinueExploringCategories from "../../components/pages/AllProducts/ContinueExploringCategories/ContinueExploringCategories";
import CeilingMetalFramesList from "../../components/pages/Accessories/AccessoriesMetals/CeilingMetalFramesList";

const CeilingMetalFrames = () => {
  return (
    <div className="accessories-page">
      <div className="accessories-page-content-guide">
        <Navbar theme="dark" />
        <AccessoriesHero title="Ceiling metal frame" imageSlot={2} />
        <CeilingMetalFramesList />
        <ContinueExploringCategories />
      </div>
      <Footer />
    </div>
  );
};

export default CeilingMetalFrames;
